export const MAX_LIST_ITEM_WIDTH = 480;
export const ICON_SIZE = 48;
export const LIST_ITEM_HEIGHT = 56;